import React from 'react';

interface InputFieldBoxProps {
  children: React.ReactNode;
  field_key: string;
}

const InputFieldContainer: React.FC<InputFieldBoxProps> = ({
  children,
  field_key,
}) => {
  return (
    <div
      key={field_key}
      className={`
        text-[#012a38] flex gap-2 group
        border-b border-solid border-form-border
        border-l border-r
      `}
    >
      {children}
    </div>
  );
};

export default InputFieldContainer;
